$(document).ready(function() {
 if ($("#Promo_box").length != 0) {
    var Promobox = {
      promoBox: $("#Promo_box"),
      promoBoxdata: $(".promo_box_data"),
      promoboxclose: $(".promo_close"),
      init: function () {
        setTimeout(Promobox.Promoboxinit(), 3000);
      },
      Promoboxinit: function () {
        if ($(window).width < 991) return false;
        Promobox.SetPromoData(Promobox.promoBox, Promobox.promoBoxdata);
        Promobox.ShowPromoBox(
          Promobox.promoBox,
          Promobox.promoBox.data("start")
        );
        Promobox.ShowPromoBoxNext(
          Promobox.promoBox,
          Promobox.promoBoxdata,
          Promobox.promoboxclose
        );
        Promobox.promoboxclose.click(function () {
          Promobox.promoBox.removeClass("newevent");
        });
      },
      SetPromoData: function ($modal, $data) {
        var i = Promobox.GetPromoIndex($data);
        var data = $data.children().eq(i);
        $modal.find(".promo_url").attr("href", data.data("url"));
        $modal
          .find(".promo_img")
          .find("img")
          .attr("src", data.data("image"))
          .attr("alt", data.data("alt"));
        $modal.find(".promo_name").text(data.data("name"));
        $modal.find(".promo_p").text(data.data("p"));
        var nummin = parseInt(data.data("min")),
          nummax = parseInt(data.data("max")),
          num = Math.floor(Math.random() * (nummax - nummin)) + nummin;
        $modal.find(".info_value").text(num);
        if (typeof data.data("text") === typeof undefined) return false;
        var str = data.data("text").split("||"),
          i = Math.floor(Math.random() * (0, str.length - 1)) + 0;
        $modal.find(".info_text").text(str[i]);
      },
      ShowPromoBox: function ($parent, delay) {
        setTimeout(function () {
          $parent.addClass("newevent");
        }, delay);
      },
      GetPromoIndex: function () {
        var min = 0,
          max = Promobox.promoBoxdata.children().length;
        return Math.floor(Math.random() * (max - min)) + min;
      },
      ShowPromoBoxNext: function ($modal, $data, $close) {
        var nextmin = $modal.data("min"),
          nextmax = $modal.data("max");
        var i = Math.floor(Math.random() * (nextmax - nextmin)) + nextmin;
        setTimeout(function () {
          $close.trigger("click");
          setTimeout(function () {
            Promobox.SetPromoData($modal, $data);
            Promobox.ShowPromoBox($modal, 0);
            Promobox.ShowPromoBoxNext($modal, $data, $close);
          }, 2000);
        }, i);
      },
    };
    Promobox.init();
  }

});  



              


